import type { ReactNode } from 'react';

/* ══════════════════════════════════════════════════════════════════════
   Shared types + Header building block for every framework layout.
   Internal to src/framework/layouts/; re-exported from index.ts.
   ══════════════════════════════════════════════════════════════════════ */

export type EyebrowTone = 'blue' | 'teal';
export type TitleAccent = 'blue' | 'teal';

export type HeaderProps = {
  eyebrow: ReactNode;
  eyebrowTone?: EyebrowTone;
  /** Muted section overline above the title (DS "section + subsection" header). */
  overline?: ReactNode;
  title?: ReactNode;
  titleSize?: 'h1' | 'h2';
  titleAccent?: TitleAccent;
  sub?: ReactNode;
};

export function Header({
  eyebrow,
  eyebrowTone = 'blue',
  overline,
  title,
  titleSize = 'h2',
  titleAccent = 'blue',
  sub,
}: HeaderProps) {
  const titleClass = `sn-${titleSize}${
    titleAccent === 'teal' ? ` sn-${titleSize}--teal-em` : ''
  }`;
  return (
    <header className="sn-header">
      <div className={`sn-eyebrow${eyebrowTone === 'teal' ? ' sn-eyebrow--teal' : ''}`}>
        {eyebrow}
      </div>
      {overline && <p className="sn-overline">{overline}</p>}
      {title && (titleSize === 'h1' ? <h1 className={titleClass}>{title}</h1> : <h2 className={titleClass}>{title}</h2>)}
      {sub && <p className="sn-sub">{sub}</p>}
    </header>
  );
}
